import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

const FIELDS = [
  { key: "title", label: "Book title", testid: "admin-edit-title-input" },
  { key: "author", label: "Author name", testid: "admin-edit-author-input" },
  { key: "tagline", label: "Short description (used for the app listing)" },
];

const inputCls =
  "mt-2 w-full rounded-sm border border-[#3E4350] bg-[#0B0C0E] px-4 py-3 text-sm text-[#F4F1EA] outline-none focus:border-[#D4A373]";
const labelCls = "block text-[10px] uppercase tracking-[0.25em] text-[#A39E93]";

export const DetailsTab = ({ meta, onSaved }) => {
  const [form, setForm] = useState({ ...meta });
  const [busy, setBusy] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const save = async () => {
    setBusy(true);
    try {
      const { id, updated_at, ...payload } = form;
      await api.put("/admin/book", payload);
      toast.success("Details saved");
      onSaved();
    } catch (e) {
      toast.error(apiError(e, "Could not save."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <p className="mb-8 text-sm leading-relaxed text-[#A39E93]">
        Your name appears at the top of the home page, and your book's title in the middle — nothing else is shown there.
      </p>
      <div className="grid grid-cols-1 gap-6">
        {FIELDS.map(({ key, label, testid }) => (
          <div key={key}>
            <label className={labelCls} htmlFor={`field-${key}`}>
              {label}
            </label>
            <input id={`field-${key}`} data-testid={testid} value={form[key] || ""} onChange={set(key)} className={inputCls} />
          </div>
        ))}
      </div>
      <button
        data-testid="admin-save-details-button"
        onClick={save}
        disabled={busy}
        className="mt-8 rounded-full bg-[#D4A373] px-8 py-3 text-xs font-semibold uppercase tracking-[0.25em] text-[#0B0C0E] transition-colors hover:bg-[#E0A96D] disabled:opacity-50"
      >
        {busy ? "Saving…" : "Save details"}
      </button>
    </div>
  );
};
